/** The two sidebar tools the conversation shell switches between (chat makeover #2718) */
export const conversationTools = ['Chat', 'Agents'] as const
export type ConversationTool = (typeof conversationTools)[number]

export function isConversationTool(name: unknown): name is ConversationTool {
  return conversationTools.includes(name as ConversationTool)
}
